export const USERS_LIST = "USERS_LIST";
export const EMPLOYEE_DETAILS = "EMPLOYEE_DETAILS";
